import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'app/AppStore';
import { getOEMFiltersMap } from 'components/Filter/Filter.types';
import FilterQuantity from 'components/Filter/FilterQuantity';
import FilterTags from 'components/Filter/FilterTags';
import {
  getIamCatalogFilters,
  getLastSearchedVehicleKey,
  setIamRangeFilter,
  setIamTextFilter,
} from 'domains/catalog/Catalog.store';
import { IAMLaborTimesNodeWrapper, IAMReferencesWrapper, OEM_BRAND_KEY } from 'domains/catalog/Catalog.types';
import { getIAMReferences } from 'domains/references';
import { getSparePartsView } from 'domains/user';
import SparePartsBrandTab from 'pages/CatalogPage/IAM/SubcategorySection/SparePartsSection/SparePartsBrandTab';
import { Flex, MarginBox } from 'UI';
import { getData, NO_DATA } from 'utils';

export interface OtherBrandSectionProps {
  referencesWrapper: IAMReferencesWrapper;
  nodeId?: string;
  laborTimesWrapper: NO_DATA | IAMLaborTimesNodeWrapper;
}

const OEMBrandSection = ({ referencesWrapper, nodeId, laborTimesWrapper }: OtherBrandSectionProps) => {
  const dispatch = useDispatch();
  const sparePartsView = useSelector(getSparePartsView);
  const filters = useSelector(getIamCatalogFilters);
  const [numOfProducts, setNumOfProducts] = useState<number>(0);
  const referencesWrapperData = getData(referencesWrapper);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const referenceNumbers = referencesWrapperData?.referenceNumbers ?? [];
  const vehicleKey = useSelector(getLastSearchedVehicleKey) ?? '';
  const iamReferencesPayload = useMemo(() => ({ vehicleKey, referenceNumbers }), [vehicleKey, referenceNumbers]);
  const references = useSelector((state: RootState) => getIAMReferences(state, iamReferencesPayload));
  const isCompatibleBatteries = references.some((r) => r.isBatteryCompatibleWithVehicle);

  return (
    <>
      <MarginBox my={15} />
      <FilterTags
        filters={filters.oemFilters}
        setTextFilters={(id, item) => dispatch(setIamTextFilter({ id, item, filterType: OEM_BRAND_KEY }))}
        setRangeFilters={(id, range) => dispatch(setIamRangeFilter({ id, range, filterType: OEM_BRAND_KEY }))}
      />
      <MarginBox my={15} />
      <FilterQuantity numberOfProducts={numOfProducts} />
      <Flex direction={'column'}>
        <SparePartsBrandTab
          sparePartsView={sparePartsView}
          referencesWrapper={referencesWrapper}
          nodeId={nodeId}
          laborTimesWrapper={laborTimesWrapper}
          setNumOfProducts={setNumOfProducts}
          isCompatible={isCompatibleBatteries}
          filterType={OEM_BRAND_KEY}
          facetsMapBuilder={getOEMFiltersMap}
        />
      </Flex>
    </>
  );
};

export default OEMBrandSection;
